// Mentions légales, version FR
// Markers [À COMPLÉTER] are kept verbatim, italicised by ReactMarkdown.

const legalNoticesFr = `# Mentions légales

*Dernière mise à jour : 13 mai 2026*

---

## 1. Éditeur du site

Le site **beyondpersonalmatrix.com** (ci-après « le Site ») est édité par :

**BPM**, Société par Actions Simplifiée (SAS) au capital social de 1 000 €
Siège social : 73, Rue du Château, 92100 BOULOGNE-BILLANCOURT (France)
Immatriculée au Registre du Commerce et des Sociétés de NANTERRE
SIREN : 987 605 567
SIRET (siège) : 987 605 567 000 14
Numéro de TVA intracommunautaire : FR86987605567

**Directeur de la publication** : *[À COMPLÉTER, vraisemblablement Gilles IACONES, président de BPM]*

**Contact** :
Courriel : support@beyondpersonalmatrix.com

Le Site exploite le service commercial **Beyond Personal Matrix** (ci-après « le Service »).

---

## 2. Hébergement

Le Site est hébergé par :

**Emergent** *(Emergent Methods, Inc., adresse à compléter selon les CGU Emergent en vigueur)*
*[À COMPLÉTER : adresse postale et coordonnées exactes de l'hébergeur à récupérer dans la documentation Emergent]*

Le nom de domaine est enregistré auprès de **Namecheap, Inc.** (4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis).

---

## 3. Propriété intellectuelle

L'ensemble des éléments composant le Site (textes, graphismes, logos, icônes, images, vidéos, sons, ainsi que leur mise en forme) est la propriété exclusive de BPM ou fait l'objet d'une autorisation d'utilisation. Toute reproduction, représentation, modification, publication, adaptation totale ou partielle des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de BPM.

La marque « **Beyond Personal Matrix** » est utilisée par BPM en tant que nom commercial. Toute utilisation non autorisée du nom commercial, du logo ou des éléments distinctifs du Service est susceptible d'engager la responsabilité de son auteur.

Les contenus psychométriques utilisés (tests DISC, Big Five, MBTI, Ennéagramme, VIA Strengths, Valeurs Schwartz) reposent sur des modèles scientifiques publics et sont mis en œuvre dans des versions adaptées par BPM.

---

## 4. Données personnelles

Le traitement des données personnelles des utilisateurs est régi par la **Politique de confidentialité** accessible à l'adresse : [beyondpersonalmatrix.com/privacy](https://beyondpersonalmatrix.com/privacy).

Pour exercer vos droits relatifs à vos données personnelles, vous pouvez écrire à : privacy@beyondpersonalmatrix.com.

---

## 5. Cookies

L'utilisation de cookies sur le Site est encadrée par la politique relative aux cookies présentée lors de votre première visite. Vous pouvez à tout moment modifier vos préférences via le bandeau de gestion des cookies.

---

## 6. Limitation de responsabilité

BPM met tout en œuvre pour assurer l'exactitude et la mise à jour des informations diffusées sur le Site. Toutefois, BPM ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur le Site.

Les résultats des tests psychométriques fournis par le Service sont produits à l'aide d'algorithmes et de modèles d'intelligence artificielle. Ces résultats ont une vocation **informative et de développement personnel** et ne sauraient en aucun cas se substituer à un avis médical, psychologique ou psychiatrique professionnel.

BPM ne saurait être tenue responsable :
- des dommages directs ou indirects résultant de l'utilisation du Site ;
- d'éventuelles interruptions ou indisponibilités du Site dues à des opérations de maintenance ou des cas de force majeure ;
- des décisions prises par les utilisateurs sur la base des résultats fournis par le Service.

---

## 7. Droit applicable et juridiction compétente

Les présentes mentions légales sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents conformément aux règles de compétence en vigueur.

Conformément aux dispositions des articles L.611-1 et suivants du Code de la consommation, le consommateur peut recourir gratuitement au service de médiation suivant :
*[À COMPLÉTER : nom et coordonnées du médiateur de la consommation auquel BPM adhère. Obligation légale pour les e-commerçants en B2C. Médiateurs courants : CNPM-Médiation, MEDICYS, Devigny Médiation, etc.]*

Le consommateur peut également utiliser la plateforme européenne de règlement en ligne des litiges : [ec.europa.eu/consumers/odr](https://ec.europa.eu/consumers/odr).
`;

export default legalNoticesFr;
